import { useApolloClient } from '@apollo/client';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppUser } from '~/components/molecules/appuser/appuser-context';
import { Box } from '@bechtel/gds';
import { EmulateButtonStyled } from './styled';
import { removeCacheKeys } from '~/utilities/session-storage';
import { EMULATED_USER_ID } from '~/components/atoms/cache-keys';
import { t, Trans } from '@lingui/macro';

export const EmulateAction: FC = () => {
  const navigate = useNavigate();
  const { user } = useAppUser();
  const client = useApolloClient();

  const onEmulate = async (e) => {
    const userBun = prompt(`${t`User Bun to Emulate:`}${'\n'}${t`Enter blank to remove emulation.`}`, '');
    if (userBun === null) return;
    //Emulate only if the provided user is different from already emulated user
    if (user?.bun !== userBun) {
      removeCacheKeys();
      //Can't use the useSessionStoragehook here as before the useEffect of the hook graphql calls are made.
      window.sessionStorage.setItem(EMULATED_USER_ID, userBun.trim());
      navigate('/', { replace: true });
      await client.resetStore();
    }
  };

  return (
    <Box p={{ sm: '400' }}>
      <EmulateButtonStyled onClick={onEmulate}>
        <Trans>Emulate</Trans>
      </EmulateButtonStyled>
    </Box>
  );
};
